import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ButtonToolbar from '../../components/ButtonToolbar';

class ProblemSubform extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	render() {
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td><FormField name="rating" /></td>
				<td><FormField name="title" /></td>
				<td><i title="Odstranit"
					   onClick={this.props.onRemove}
					   onMouseOver={() => this.handleMouseOver()}
					   onMouseOut={() => this.handleMouseOut()}
					   className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
}

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'checkpoint.fetch',
			save: 'checkpoint.save',
			remove: 'checkpoint.delete'
		};

		this.changeEvent = 'checkpoint.change';

		this.messages = {
			remove: 'Opravdu si přejete kontrolní bod odstranit?',
			notfound: 'Kontrolní bod nenalezen!'
		};

		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Název je povinná položka!'}
				}
			},
			priority: {
				class: Number,
				label: 'Pozice',
				style: {width: 60}
			},
			items: {
				class: Multiform,
				label: 'Závady',
				addLabel: 'přidat závadu',
				value: [{id: -1, title: ''}],
				subform: ProblemSubform,
				schema: {
					rating: {
						class: Select,
						options: DbInfo.Rating,
						clearable: false,
						label: 'Úroveň'
					},
					title: {
						class: TextInput,
						label: 'Text',
						style: {width: 700}
						/*rules: {
						 	presence: {message: 'Text je povinná položka!'}
						}*/
					}
				}
			}
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Kontrolní bod">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<div className="row">
						<div>
							<table className="form">
								<tbody>
								{Object.keys(this.schema).map((key) => {
									return <FormRow key={key} visible={this.schema[key].visible} name={key} labelWidth={135}/>
								})}
								</tbody>
							</table>
						</div>
					</div>
					{!this.props.popup &&
					<div style={{textAlign:'right'}}>
						{saveCloseButton}
					</div>}
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Checkpoint/Form.js